import Translate from "../../../translation/utils/translateFunction";

export const InitialValues = {
  companyId: "",
  name: "",
  documentCategory: "",
  title: "",
  registrationDate: "",
  expiryDate: "",
  attachment: "",
  isNotExpiry: false,
};

export const docCategory = [
  {
    label: "License | رخصة",
    value: "License",
  },
  {
    label: "Assets | أصول",
    value: "Assets",
  },
  {
    label: "Other | آخر",
    value: "Other",
  },
];

export const checkBoxOption = [Translate("renewals:renewalCheckBox")];

export const sortingOptions = [
  {
    label: Translate("renewals:default"),
    value: "default",
  },
  {
    label: Translate("renewals:atoz"),
    value: "AtoZ",
  },
];
